export default `---
slug: mexico
country: Mexico
countryCode: MEX
continent: Americas
year: 2016
title: "José, Keep Them Coming"
description: "Technically cruise ship stops, technically 17 years old, and technically not supposed to be doing any of this. Mexico delivered anyway."
thumbnail: /images/travels/MEX/cover.jpg
relatedLinks: []
---

I should be upfront about something: I did not visit Mexico in any traditional sense of the phrase. There was no arrival at an airport, no hotel, no exploring the country. I was 17 and in the United States on a student exchange, and the cruise ship we took in October made two stops on the Mexican coast. That's my Mexico.

It's still a great story.

## The Cruise Ship That Almost Wasn't

The first cruise trip didn't quite make it. There was a medical situation with another passenger on board and we couldn't dock at the Mexican stops. That was the first one. The second cruise was just me and my host mom — two stops, both Mexico, both beach days. And that's where things got interesting.

## An Arrangement With José

The first stop was an all-inclusive beach: all you can eat, all you can drink, sunshine, warm ocean, the whole thing. My host mom, who knew perfectly well that I wasn't exactly a stranger to beer back in Italy, told me I could have two. Two beers. Reasonable position.

I found our waiter — his name was José — and ordered the first one. Drank it, left the empty glass on my sunbed, and went for a swim. When I came back, José had already replaced it. Full glass, waiting for me. I mean — it was already there. What was I going to do?

I drank it. Sunbathed a little. Glass empty again. José appeared again.

<b>You see where this is going.</b>

At some point I found a group of American students on spring break and started socialising with them. One thing led to another. By four in the afternoon I was completely and comprehensively hammered — on an empty stomach, having barely touched the food, after weeks of not drinking a drop in the US. My host mom was <i>not pleased.</i>

I remember the taxi ride back to the ship with perfect clarity: my head pressed against the window glass, just barely surviving each turn, the air conditioning doing heroic work. My host mom sat next to me in total silence, which was somehow worse.

## The Sprite Strategy

The second stop, she had clearly done some thinking. Categorical no on the alcohol. No discussion. I accepted this gracefully and immediately started working around it.

The trick was simple: I would walk up to the bar, order a shot of tequila and a glass of Sprite, take the shot quickly, and then be casually holding just a Sprite when she came to check on me. Which she did. Frequently. She would taste my drink — <i>Sprite, clearly Sprite</i> — and walk away satisfied.

I did this approximately five times.

---

I did not visit Mexico. I spent two days on its beaches, got drunk by early afternoon on the first one, and spent the second one playing volleyball and quietly consuming tequila through a cover story.

No complaints whatsoever. I cannot complain, not one bit.
`;
